import axios from 'axios';
import { KEYWORDS_CLOUD_DATA_KEY } from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {
    DATA_KEY: () => KEYWORDS_CLOUD_DATA_KEY
};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, properties, limit, ...additionalParams }) {
        const params = {
            range,
            limit,
            accountId,
            ...additionalParams,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/keyword_cloud', {
            params,
            encodeURI: true
        });
    }
};
